/* eslint-disable camelcase */
import React, {useEffect, useState} from 'react'
import {useStaticQuery, graphql} from 'gatsby'
import PropTypes from 'prop-types'
import Layout from '../components/layout'
import {isUnsupported} from '../util/userAgent'

import {getExperimentConfig} from '../experimentFramework/experiment'
import EXPERIMENT_CONFIG from '../experimentFramework/experimentConfig.json'

import IndexUnsupported from '../components/unsupported/index-unsupported'
import Index4624 from '../components/templates/sp-4624/index-4624'
import AppPage from '../components/templates/app-v1/app'
import VanishPage from '../components/templates/vanish-v1/vanish'
import PrivateAIPage from '../components/templates/privateai-v1/privateai'
import SEO from '../components/seo'
import AppFavicons from '../components/templates/app-v1/AppFavicons'

const IndexPage = ({languageCode}) => {
    const site = useStaticQuery(graphql`
        query IndexPage {
            site {
                siteMetadata {
                    ...AddStartpageCom
                }
            }
        }
    `)
    const localizedData = site.site.siteMetadata.addStartpageCom[languageCode]

    const [expConfig, setExpConfig] = useState(null)
    const [showUnsupportedPage, setShowUnsupportedPage] = useState(false)

    useEffect(() => {
        // for advertorials, redirect homepage to www.startpage.com - we only buy to nested routes for advertorial for now
        // if (window.location.hostname.startsWith('private')) {
        //     window.location.href = 'https://www.startpage.com'
        //     return
        // }
        if (!expConfig) {
            setExpConfig(getExperimentConfig(EXPERIMENT_CONFIG))
        }
        if (isUnsupported()) {
            setShowUnsupportedPage(true)
        }
    }, [expConfig])

    const ExperimentComponent = (config) => {
        // NOTE: leaving this commented as an example of how you add a new experiment
        // const {experiment} = config
        // if (isExperiment(config, 'sp-415')) {
        //     return <Index4624 experiment={experiment} />
        // }
        if (!config) {
            return <></>
        }
        if (typeof window !== `undefined`) {
            if (window.location.href.match(/privateai.*startpage\.com/gi)) return <PrivateAIPage languageCode={languageCode} />
            if (window.location.href.match(/vanish.*.com/gi)) return <VanishPage languageCode={languageCode} />
            if (window.location.href.match(/app.*.com/gi)) return <AppPage languageCode={languageCode} />
        }
        if (showUnsupportedPage) {
            return <IndexUnsupported experiment="unsupported" />
        }
        return (
            <Layout>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <Index4624 experiment="sp-4624" languageCode={languageCode} {...localizedData} />
            </Layout>
        )
    }

    // This block is what's rendered on the page (serverside and clientside)
    return (
        <>
            {/* default to showing the app favicons - otherwise favicons don't show on mobile safari or chrome */}
            <AppFavicons />
            {ExperimentComponent(expConfig)}
        </>
    )
}

IndexPage.propTypes = {
    languageCode: PropTypes.string,
}

IndexPage.defaultProps = {
    languageCode: `en`,
}

export default IndexPage
